<!-- Component can be used in microscope and periscope -->
<template>
  <table>
    <slot />
  </table>
</template>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;

  :deep(th) {
    text-align: start;
    font-weight: normal;
  }
}
</style>
